import React, { useState } from 'react'
import imageSpinner from '../../assets/image-spinner.gif'
import BasicPlaceholder from '../../assets/basic-placehoder.jpg'

const CustomImage = ({
  imageUrl,
  imgStyle = {},
  imgClass = '',
  imgAlt = 'placehoder',
  errorPlaceholder = BasicPlaceholder,
  loaderClass = '',
  loaderStyle = {},
}) => {
  const [imgLoaded, setImgLoaded] = useState(false)

  const imageStyle = !imgLoaded ? { display: 'none' } : { ...imgStyle }
  return (
    <>
      {!imgLoaded && (
        <div style={loaderStyle} className={`flex items-center justify-center ${loaderClass}`}>
          <img src={imageSpinner} className="w-4 h-4 md:w-8 md:h-8" alt="spinner" />
        </div>
      )}
      <img
        src={imageUrl}
        style={imageStyle}
        className={imgClass}
        alt={imgAlt}
        onLoad={() => setImgLoaded(true)}
        onError={({ currentTarget }) => {
          currentTarget.onerror = null // prevents looping
          currentTarget.src = errorPlaceholder
        }}
      />
    </>
  )
}

export default CustomImage
